import { render, staticRenderFns } from "./iframeRedirect.vue?vue&type=template&id=3e09fbbb"
import script from "./iframeRedirect.vue?vue&type=script&lang=js"
export * from "./iframeRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports